<template>
  <div id="H0" class="sub">
    <div class="wrapper">
      <kg-header :headerType="Number(headerType)" />
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">FAQ</h1>
          <section class="sec_faq" v-for="(faq,i) in faqList" :key="i">
            <h2 class="tit_faq">【{{faq.title}}】</h2>
            <ul class="lst_faq">
              <li v-for="(item,index) in faq.questions" :key="index">
                <span class="question" @click="questionClick(faq.key + index)">
                  <span class="ico">Q.</span>
                  <span class="ins_wrap">
                    <span class="tx">{{item.q}}</span>
                  </span>
                </span>
                <div class="answer_wrap" v-bind:id="faq.key + index">
                  <p class="answer">
                    <span class="ico">A.</span>
                    <span class="ins_wrap">
                      <span class="tx">{{item.a}}</span>
                    </span>
                  </p>
                </div>
              </li>
            </ul>
            <div class="link_area">
              <a @click="contactClick()">お問い合わせ</a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// kagull Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  props: {
    headerType: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      appFaqList: [
        {q: '色素材の見本を見ることはできますか？', a: '色素材の見本を見ることはできますか？'},
        {q: 'オーダー家具を検討する際、注意する点はありますか？', a: 'どうしても、家具のデザインや色柄ばかりに注意がいってしまい、家具を置こうとする場所と収納動線が一致していないと、使い勝手の悪いプランとなってしまう場合があるようです。「この場所にはこんな機能の収納を」「この壁には細かい物をしまえる薄い引出しを」といったように、住まい方に合わせた収納プランが重要となります。'},
        {q: '対応機種は限られますか？', a: '対応機種は限られますか？'}
      ],
      productFaqList: [
        {q: '納期はどのくらいですか？', a: '納期はどのくらいですか？'},
        {q: '配送日時は指定できますか？', a: '配送日時は指定できますか？'},
        {q: '設置施工には、どの位の時間がかかりますか？', a: '設置施工には、どの位の時間がかかりますか？'}
      ],
      afterFaqList: [
        {q: '御社へ伺って直接会って相談したいのですが？', a: '御社へ伺って直接会って相談したいのですが？'},
        {q: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？', a: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？'},
        {q: 'ホルムアルデヒドなど心配です。どのような基準ですか？', a: 'ホルムアルデヒドなど心配です。どのような基準ですか？'}
      ],
      optionFaqList: [
        {q: 'メールで相談したいのですが？', a: 'メールで相談したいのですが？'},
        {q: '配送日時は指定できますか？', a: '配送日時は指定できますか？'},
        {q: '設置施工には、どの位の時間がかかりますか？', a: '設置施工には、どの位の時間がかかりますか？'}
      ],
      kagullFaqList: [
        {q: 'サービス対応地域はどちらになりますか？', a: 'サービス対応地域はどちらになりますか？'},
        {q: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？', a: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？'},
        {q: 'ホルムアルデヒドなど心配です。どのような基準ですか？', a: 'ホルムアルデヒドなど心配です。どのような基準ですか？'}
      ],
      kagullerFaqList: [
        {q: 'サービス対応地域はどちらになりますか？', a: 'サービス対応地域はどちらになりますか？'},
        {q: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？', a: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？'},
        {q: 'ホルムアルデヒドなど心配です。どのような基準ですか？', a: 'ホルムアルデヒドなど心配です。どのような基準ですか？'}
      ],
      otherFaqList: [
        {q: 'サービス対応地域はどちらになりますか？', a: 'サービス対応地域はどちらになりますか？'},
        {q: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？', a: '家具の製作をお願いしたいと思っております。依頼方法が３つあるようですが、一番早くできる方法はどれですか？'},
        {q: 'ホルムアルデヒドなど心配です。どのような基準ですか？', a: 'ホルムアルデヒドなど心配です。どのような基準ですか？'}
      ],
      faqList: [
        {key: 'app', title: 'アプリについて', questions: []},
        {key: 'product', title: '商品について', questions: []},
        {key: 'after', title: '購入後の商品について', questions: []},
        {key: 'option', title: 'オプションについて', questions: []},
        {key: 'kagull', title: 'カグルについて', questions: []},
        {key: 'kaguller', title: 'カグラーについて', questions: []},
        {key: 'other', title: 'その他について', questions: []}
      ]
    }
  },
  methods: {
    init: function () {
      this.faqList[0].questions = this.appFaqList
      this.faqList[1].questions = this.productFaqList
      this.faqList[2].questions = this.afterFaqList
      this.faqList[3].questions = this.optionFaqList
      this.faqList[4].questions = this.kagullFaqList
      this.faqList[5].questions = this.kagullerFaqList
      this.faqList[6].questions = this.otherFaqList
    },
    questionClick: function (targetId) {
      // アンサーの表示非表示切り替え
      let target = document.getElementById(targetId)
      if (target.style.display === 'block') {
        target.style.display = 'none'
      } else {
        target.style.display = 'block'
      }
      if (target.parentElement.classList.contains('active')) {
        target.parentElement.classList.remove('active')
      } else {
        target.parentElement.classList.add('active')
      }
    },
    contactClick: function () {
      this.$router.push('/kagull/support/input/' + this.headerType)
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/Faq.vue